module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("{ " + _vm._s(_vm.name) + " "), _c('span', [_vm._v(_vm._s(_vm.desc))]), _vm._v(" }")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ab502f7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/appHeader.vue
// module id = 52
// module chunks = 1